<script setup>
import BillingAddress from "@/Components/Blocks/Checkout/BillingAddress.vue";
import CheckoutBlack from "@/Components/Blocks/Checkout/CheckoutBlack.vue";
import ContactInformation from "@/Components/Blocks/Checkout/ContactInformation.vue";
import CouponCode from "@/Components/Blocks/Checkout/CouponCode.vue";
import ShippingAddress from "@/Components/Blocks/Checkout/ShippingAddress.vue";
import ShippingRate from "@/Components/Blocks/Checkout/ShippingRate.vue";
import Button from "@/Components/Buttons/Button.vue";
import Checkmark from "@/Components/Input/Checkmark.vue";
import Form from "@/Components/Input/Form.vue";
import {useCart} from "@/stores/cart";
import {mapErrors} from "@/utilities";
import {Link, useForm, usePage} from "@inertiajs/vue3";
import {inject} from "vue";

const cart = useCart();
const route = inject("route");

defineProps({
    shipping_rate_options: Object,
});

const form = useForm({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    password: "",
    password_confirmation: "",
    shipping_address: {
        street_name: "",
        street_number: "",
        street_number_addition: "",
        postcode: "",
        city: "",
    },
    billing_address: {
        street_name: "",
        street_number: "",
        street_number_addition: "",
        postcode: "",
        city: "",
    },
    billing_address_same_as_shipping_address: true,
    terms_and_conditions: false,
    shipping_rate_id: cart.shippingRate?.id ?? null,
});

function submitForm() {
    form.post(route("public.orders.store"), {
        preserveScroll: true,
        onError: (errors) => (form.errors = mapErrors(errors)),
    });
}

</script>

<template>
    <div class="container mt-10 md:mt-15">
        <h2 class="mb-10 text-2xl font-bold uppercase lg:text-3xl xl:leading-12">
            {{ $t("Checkout") }}
        </h2>

        <div class="mb-30 flex flex-col gap-8 lg:flex-row">
            <div class="flex flex-1 flex-col gap-4">
                <div
                    v-if="!cart.hasProductVariants"
                    class="text-6"
                >
                    {{ $t("Your shopping cart is empty") }}
                </div>
                <Form
                    v-else
                    class="flex flex-col gap-4"
                >
                    <ContactInformation :form="form" />

                    <ShippingAddress :form="form" />

                    <BillingAddress :form="form" />


                    <ShippingRate
                        :form="form"
                        :shipping-rate-options="shipping_rate_options"
                    />


                    <Checkmark
                        v-model:value="form.terms_and_conditions"
                        :errors="form.errors.terms_and_conditions"
                    >
                        <div class="leading-tight">
                            Ik ga akkoord met de
                            <Link
                                :href="route('public.pages.show', usePage().props.commerceSettings.terms_page_slug)"
                                class="font-bold underline"
                            >
                                Algemene Voorwaarden
                            </Link>

                            en
                            <Link
                                :href="route('public.pages.show', usePage().props.commerceSettings.privacy_page_slug)"
                                class="font-bold underline"
                            >
                                Privacy Verklaring
                            </Link>
                        </div>
                    </Checkmark>
                </Form>
            </div>
            <CheckoutBlack
                v-if="cart.hasProductVariants"
                :shipping-rate="cart.shippingRate"
            >
                <CouponCode />
                <div class="mt-4" />
                <Button
                    v-if="cart.hasProductVariants"
                    :form="form"
                    remove-width
                    classes="w-full"
                    :label="$t('Place order')"
                    @click="submitForm"
                />

                <div class="flex">
                    <Link
                        class="w-full px-8 pt-6 text-center text-white underline"
                        :href="
                            route('public.pages.show', {
                                slug: usePage().props.commerceSettings?.shopping_cart_page_slug,
                            })
                        "
                    >
                        {{ $t("Back to the shopping cart") }}
                    </Link>
                </div>
            </CheckoutBlack>
        </div>
    </div>
</template>
